/**
 * Browser-safe vm shim.
 * Some transitive dependencies probe vm.runInThisContext and fallback when
 * unavailable; throwing here preserves that behavior without using eval.
 */
export function runInThisContext(): never {
  throw new Error('vm.runInThisContext is not available in browser builds');
}

export class Script {
  runInThisContext(): never {
    throw new Error('vm.Script is not available in browser builds');
  }
}

const vmShim = {
  runInThisContext,
  Script,
};

export default vmShim;
